export default __webpack_public_path__ + "static/media/Breastplate of Red Ruin.e4302deb.jpg";